<template>
  <div>
    <loading v-show="showLoader" />
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'ComplaintFeedback' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Claims</h2>
              <p class="listing-page-desc" style="text-transform: capitalize;">{{ MajorClass ? MajorClass.replace(/_/g," ") : '' }}</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container multistep-box">
        <div class="row mb-4">
          <div class="col-12 ib-border-b">
            <ul class="list-inline">
              <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Claim Listing</h1></li>
              <form action="" class="float-md-right ml-md-auto list-position">
                <li class="list-inline-item">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <div class="jbl-field in-search-field">
                        <input type="text" id="texto" class="jbl-dynamic-input" placeholder="Search here..." v-on:keyup="filterSearch" v-model="searchFilter"/>
                      </div>
                    </li>
                    <!-- <li class="list-inline-item">
                      <div class="field jbl-responsive-btn">
                        <router-link :to="{ name: 'Products' }" class="ib-btn-primary ib-btn-width ib-btn-hover">ADD POLICY</router-link>
                      </div>
                    </li> -->
                  </ul>
                </li>
              </form>
            </ul>
          </div>
          <!-- <div class="col-12 ib-border-b">
            <ul class="list-inline">
              <li class=""><h1 class="ib-claim-listing">Claim Listing</h1></li>
              <form action="" class="float-right ml-auto" style="position: relative; bottom: 48px;">
                <li class="list-inline-item">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <div class="jbl-field">
                        <input type="text" id="texto" class="jbl-dynamic-input" placeholder="Search here..." v-on:keyup="filterSearch" v-model="searchFilter"/>
                      </div>
                    </li>
                  </ul>
                </li>
              </form>
            </ul>
          </div> -->
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="listing-nav">
              <div class="d2c-main-classes">
                <button class="d2c-class-btn" :class="MajorClass == major_class ? 'active' : ''" v-for="(major_class, key) in major_classes" @click="LoadClaims(major_class)">
                  <div class="in-right-border" style="text-transform: capitalize;">
                    {{  major_class.replace(/_/g," ") }}
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12 d-none d-md-block" id="self-Claim">
            <table class="claim-listing">
              <tbody>
              <tr v-on:click="show_feedback_form($event, 'claim', self_claim.id )" v-for="self_claim in self" :key="self_claim.id">
                <!-- <td class="jbl-responsive-td data-img">
                  <img alt="icon" class="img-fluid" width="100px;" :src="self_claim.plan_image" v-if="self_claim.plan_name != ''" />
                  <img alt="icon" class="img-fluid" width="100px;" :src="self_claim.product_image" v-else />
                  <div class="position-relative-box">
                    <img alt="icon" class="img-fluid small-icon" :src="self_claim.company_logo_path" />
                  </div>
                </td> -->
                <td class="jbl-responsive-td data-img">
                  <div class="in-listing-img">
                    <img class="img-fluid" :src="self_claim.plan_image" v-if="self_claim.plan_name != ''" />
                    <img class="img-fluid" :src="self_claim.product_image" v-else />
                    <div class="position-relative-box">
                    <img alt="icon" class="img-fluid small-icon" :src="self_claim.company_logo_path" />
                    </div>
                  </div>
                </td>
                <td class="jbl-table-heading jbl-responsive-td" v-if="self_claim.plan_name !== ''">{{ self_claim.subclass_name }}
                  <small>{{ self_claim.product_name }}</small>
                  <small class="ib-card-plan">{{ self_claim.plan_name }}</small>
                </td>
                <td class="jbl-table-heading jbl-responsive-td" v-else>{{ self_claim.subclass_name }}
                  <small  class="ib-card-plan">{{ self_claim.product_name }}</small>
                </td>
                <td class="jbl-responsive-td">
                  <div class="jbl-flex-td">
                    <div class="jbl-date-td jbl-date-heading">Claim No.</div>
                    <div class="jbl-date-td">{{ self_claim.claim_no }}</div>
                  </div>
                </td>
                <td class="jbl-responsive-td">
                  <div class="jbl-flex-td">
                    <div class="jbl-date-td jbl-date-heading">Date:</div>
                    <div class="jbl-date-td">{{ formatDate(self_claim.created_at) }}</div>
                  </div>
                </td>
                <td class="jbl-responsive-td"><div class="ib-status " :class="self_claim.status +'-status'">{{ self_claim.status }}</div></td>
                <td class="jbl-responsive-td">
                  <i class="fa fa-chevron-right"></i>
                </td>
              </tr>
              </tbody>
            </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="customer_self_policies_filterd.length === 0">No Claim Found</h2>
          </div>

          <!-- mobile view -->
          <div class="col-md-12 d-md-none">
            <div class="d-flex in-sm-listing" v-on:click="show_feedback_form($event, 'claim', self_claim.id )" v-for="self_claim in self" :key="self_claim.id">
              <div class="in-sm-firstdiv">
                <div class="in-listing-img in-sm-height">
                  <img class="img-fluid" :src="self_claim.plan_image" v-if="self_claim.plan_name != ''" />
                  <img class="img-fluid" :src="self_claim.product_image" v-else />
                  <div class="position-relative-box">
                  <img alt="icon" class="img-fluid small-icon" :src="self_claim.company_logo_path" />
                  </div>
                </div>
              </div>
              <div class="in-sm-flex1">
                <div class="d-flex in-sm-date">
                  <div>Date:&nbsp;</div>
                  <div>{{ formatDate(self_claim.created_at) }}</div>
                </div>
                <div class="in-sm-title" v-if="self_claim.plan_name !== ''">{{ self_claim.subclass_name }}
                  <small>{{ self_claim.product_name }}</small>
                  <small class="ib-card-plan">{{ self_claim.plan_name }}</small>
                </div>
                <div class="in-sm-title" v-else>{{ self_claim.subclass_name }}
                  <small class="ib-card-plan">{{ self_claim.product_name }}</small>
                </div>
                <div>
                  <div class="d-flex">
                    <div class="in-sm-property">Claim No</div>
                    <div class="in-sm-value">{{ self_claim.claim_no }}</div>
                  </div>
                </div>
                  <div class="in-sm-status ib-status" :class="self_claim.status +'-status'">{{ self_claim.status }}</div>
              </div>
            </div>
            <h5 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center;" v-if="customer_self_policies_filterd.length === 0">No Claim Found</h5>
          </div>
          <!-- mobile view -->

        </div>
      </div>
      <div id="myModal" role="dialog" v-if="showFeedbackModal" class="modal show" style="display: block;" aria-modal="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
          <div class="modal-content py-3">
            <form v-on:submit="submit_review" id="submit_review">
              <div class="modal-header ib-modal-header">
                  <span class="ib-m-close ib-x-m-icon" data-dismiss="modal" @click="showFeedbackModal = false">
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                  </span>
                </div>
              <div class="modal-body in-claim-feedback-scroll">
                <div class="jbl-user-survey" v-for="(fields, key) in custom_fields">
                  <h1 class="jbl-feedback-title d-block"><b>{{ key = key+1 }}-</b> {{ fields.label }}</h1>
                  <div class="options hiddenradio radio-width-img">
                    <div style="position:relative;" v-for="default_values in fields.default_values">
                      <label :for="default_values.id">
                        <input class="jbl-radio-position" type="radio" :name="fields.field_name" :value="default_values.id" :key="default_values.field_name" :id="default_values.id" required>
                        <img :src="default_values.enable_icon"  @click="CheckMark(default_values.id, default_values.enable_icon)" >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer" style="border:none !important;">
                <div class="mx-auto text-center">
                  <button type="submit" class="ib-btn-primary ib-btn-width mr-2">Submit</button>
                  <button type="button" class="ib-btn-outline ib-btn-width" data-dismiss="modal" @click="showFeedbackModal = false">Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";

  export default {
    name: 'Complaint',
    components: {
      loading
    },
    data() {
      return {
        showLoader: false,
        self_claims: {},
        nominated_claims: {},
        self: {},
        nominated: {},
        customer_self_policies: {},
        customer_nominated_policies: {},
        customer_self_policies_filterd: {},
        customer_nominated_policies_filterd: {},
        custom_fields: {},
        self_claim_area: true,
        nominated_claim_area: false,
        self_claims_area: true,
        nominated_claims_area: false,
        type: 0,
        id: 0,
        showFeedbackModal: false,
        exp_title : 'Nice',
        imgPath : require('@/assets/images/normal.svg'),
        current_state: 'self',
        major_classes: {},
        first_class: '',
        MajorClass: '',
        searchFilter: ''
      };
    },
    created: function () {
      const self = this;
      self.getClaims();
    },
    methods: {
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async getClaims() {
        const self = this;
        self.showLoader = true;
        await axios.get('customer/claims').then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.self_claims = resp.data.data.self_policies_claims;
            self.nominated_claims = resp.data.data.nominated_policies_claims;
            self.self = resp.data.data.self_policies_claims;
            self.nominated = resp.data.data.nominated_policies_claims;

            let main_classes = [];
            self.self_claims.forEach(element => {
              main_classes.push(element.mainclass_name);
            });
            let filtered_main_classes = main_classes.filter((item, i, ar) => ar.indexOf(item) === i);
            self.major_classes = filtered_main_classes;
            self.MajorClass = filtered_main_classes[0];

            self.LoadClaims(self.MajorClass);
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      LoadClaims(class_name) {
        const self = this;
        self.self = {};
        self.MajorClass = class_name;
        if(self.searchFilter != '') {
          self.self = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name.replace(/ /g,"_").toLowerCase() && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
            || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
            || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
            || x.claim_no.includes(self.searchFilter.toLowerCase())
            || x.policy_no.includes(self.searchFilter.toLowerCase())));
        } else {
          self.self = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase().includes(class_name.replace(/ /g,"_").toLowerCase()));
        }
      },
      filterSearch() {
        const self = this;
        self.self = {};
        let class_name = self.MajorClass.replace(/ /g,"_").toLowerCase();

        if(self.MajorClass != '') {
          if(self.current_state == 'self') {
            self.self = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          } else {
            self.nominated = self.nominated_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          }
        } else {
          if(self.current_state == 'self') {
            self.self = self.self_claims.filter(x =>  x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          } else {
            self.nominated = self.nominated_claims.filter(x =>  x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          }
        }
      },
      viewComplaint(complainId) {
        const self = this;
        self.$router.push({ name: 'ComplaintView', params: { id: complainId } });
      },
      async show_feedback_form(e, type, id) {
        const self = this;
        self.type = type;
        self.id = id;
        self.showLoader = true;
        await axios.post("customer/feedback/form_fields", { refer_for: type, refer_for_id: id }).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            var obj_keys = Object.keys(resp.data.data.feedback_forms);
            self.custom_fields = resp.data.data.feedback_forms[obj_keys].custom_fields;
            self.showFeedbackModal = true;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async submit_review(e) {
        const self = this;
        e.preventDefault();
        self.showLoader = true;
        var formData = new FormData(document.getElementById('submit_review'));
        formData.append('refer_for', self.type);
        formData.append('refer_for_id', self.id);

        await axios.post('customer/feedback/store_feedback', formData).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            $toast.success(resp.data.message, { position: 'top-right' });
            self.showFeedbackModal = false;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
    }
  };
</script>

<style scoped>
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
  .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
    padding: 0px !important; 
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child{
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
  }

  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes {
    background-color: #def3f7;
    border-radius: 31px;
    max-width: fit-content;
    margin: 1px 0 30px;
  }
  .d2c-class-btn {
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    height: 61px;
    margin: 0 0 1px;
    border-radius: 31px;
    background-color: #def3f7;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    color: #4c505d;
    transition: all .3s ease-in;
  }
  @media(max-width:550px){
    .d2c-class-btn{
      padding: 6px 22px !important;
      width: max-content !important;
      font-size: 12px !important;
    }
  }
  .d2c-class-btn:hover {
    background-color: #049cbd;
    color: white;
  }
  .d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
    outline: none !important;
    background-color: #049cbd;
    color: white;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  @media (min-width: 669px){
    table.claim-listing tbody td:first-child {
      width: 110px !important;
    }
  }
  /* feedback radio css */
  .label {
    position: absolute;
    top: 0;
    right: 1px;
    bottom: 1px;
    left: 0.5em;
    z-index: 1;
    font-size: 13px;
    color: #999;
    white-space: nowrap;
    cursor: text;
    transition: all 0.1s ease;
  }

  .input-placeholder:focus ~ label,
  .input-placeholder:valid ~ label {
    font-size: 11px;
    left: 10px;
    top: -10px;
  }

  .input-placeholder:valid ~ label {
    color: green;
  }

  .input-placeholder:focus:invalid ~ label {
    color: red;
  }
  @media (max-width: 668px) {
    .data-img img {
      width: 60%;
      height: auto;
      padding: 0.5rem;
    }
  }
  .jbl-rating-heaing {
    font-family: "Avenir Medium";
    font-size: 20px;
    /* font-weight: 900; */
    letter-spacing: -0.01px;
    text-align: center;
    color: #5b6770;
    padding-top: 1.5rem;
  }

  .jbl-rating-subheading {
    font-family: "Avenir Medium";
    font-size: 39px;
    font-weight: 500;
    letter-spacing: -0.01px;
    text-align: center;
    color: #845bb3;
  }

  .jbl-rating-box {
  padding: 1.5rem;
  border-radius: 10px;
  border: solid 1px #dedada;
  background-color: #ffffff;
  box-shadow: 0 3px 26px 0 rgb(0 0 0 / 8%);
  position: relative;
  bottom: 5rem;
}
.jbl-rating-img{
  position: relative;
  text-align: center;
  top: 0.6rem;
  z-index: 1;
}
.jbl-feedback-title{
  font-family: "Avenir Book";
  font-size: 17px;
  font-weight: normal;
  line-height: 1.24;
  text-align: left;
  color: #5b6770;
}
.rating-status {
  font-family: "Avenir Book";
  font-size: 11px;
  font-weight: normal;
  line-height: 2.09;
  letter-spacing: normal;
  text-align: center;
  color: #c6c5c5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.rating-status img{
  max-width: 55px;
}
@media(max-width:420px){
  .rating-status img{
  max-width: 45px;
  }
}
/* input[type="radio"]{
  appearance: none;
} */
.jbl-user-survey{
  overflow-x: hidden;
}
.radio-width-img{
    display: flex;
    justify-content: flex-start;
}
.radio-width-img img{
      width: 5rem;
      margin-left: .4rem;
      margin-right: .4rem;
  }
.jbl-radio-position{
    position: absolute;
    top: 14px;
    left: 23px;
}
@media (max-width:550px){
    .radio-width-img img{
      width: 3.8rem;
      margin-left: 0px;
      margin-right: 0px;
  }
  .jbl-radio-position{
    position: absolute;
    left: 12px;
    top: 9px;
  }
}
/* @media (max-width:420px){
    .radio-width-img img{
      width: 3.2rem;
      margin-left: .3rem;
      margin-right: .3rem;
  }
  .jbl-radio-position{
    position: absolute;
    left: 0;
    top: -7px;
  }
} */
@media (min-width: 786px){
  .jbl-feedback-dialog {
      max-width: 700px !important;
      margin: 1.75rem auto !important;
  }
  .radio-width-img img{
    width: 7rem;
    margin-left: .4rem;
    margin-right: .4rem;
}
  .jbl-radio-position{
    position: absolute;
    left: 32px;
    top: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Feedback/Claims.vue